import { createStore, createHook, type Action } from 'react-sweet-state';
import type { IssueKey } from '@atlassian/jira-shared-types';
import { type SidebarStoreState as State, SidebarStatuses } from './types';

const { CLOSED, SHOWING_ISSUE, SHOWING_CONFIGURATION, SHOWING_INSIGHTS } = SidebarStatuses;

const initialState: State = {
	// NOTE: we store status and issueKey inside a 'state' object because they are
	// related to each other. e.g. if status is ShowingIssue then issueKey must exist
	// flow can't handle this with the main state object because it uses partial state
	state: {
		status: CLOSED,
	},
};

export const actions = {
	close:
		(): Action<State> =>
		({ setState }) =>
			setState({ state: { status: CLOSED } }),
	showIssue:
		(issueKey: IssueKey): Action<State> =>
		({ setState }) =>
			setState({ state: { status: SHOWING_ISSUE, issueKey } }),
	showConfiguration:
		(): Action<State> =>
		({ setState }) =>
			setState({ state: { status: SHOWING_CONFIGURATION } }),
	showInsights:
		(): Action<State> =>
		({ setState }) =>
			setState({ state: { status: SHOWING_INSIGHTS } }),
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: 'deploymentsSidebarStore',
	initialState,
	actions,
});

const useStore = createHook(Store);

// Export a version that hides the weird `state` property from consumers
export const useSidebarStore = () => {
	const [{ state }, sidebarActions] = useStore();
	return [state, sidebarActions] as const;
};

const useSidebarWithoutState = createHook(Store, {
	selector: null,
});

export const useSidebarActions = () => {
	const [, sidebarActions] = useSidebarWithoutState();
	return sidebarActions;
};

export const useSidebarIssueKey = createHook(Store, {
	// @ts-expect-error - TS2339 - Property 'issueKey' does not exist on type 'SidebarState'.
	selector: (state) => state.state.issueKey || null,
});
